<script>
import Navbar from "@/view/front/components/navbar";
import Switcher from "@/view/front/components/switcher";
import Footer from "@/view/front/components/footer";
import axios from "axios";
import { API_URL, MEDIA_URL } from "@/core/api";
// import Skeleton from "@/view/front/components/skeleton";
import moment from "moment";
import Swal from "sweetalert2";
import Multiselect from "vue-multiselect";
import IndexService from "@/MainServices/IndexService.js";

/**
 * page-jobs-new component
 */
export default {
  metaInfo: function() {
    return {
      title: "Networking skills - Find Your Dream Job - job4u.pk",
      meta: [
      { name: 'description', content:  "Love them or hate them, networking skills are widely considered the central tenet of success in the professional world." }
      ]
    }
  },
  data() {
    return {
      auth: localStorage.getItem("id_token") !== null ? true : false,
      token: `Bearer ${localStorage.getItem("token")}`,
      user:
        localStorage.getItem("user") !== null
          ? JSON.parse(localStorage.getItem("user"))
          : {},
      profile:
        localStorage.getItem("profile") !== null
          ? JSON.parse(localStorage.getItem("profile"))
          : {},
      loading: true,
      mediaUrl: MEDIA_URL,
      apiUrl: API_URL,
      keywords: "",
      email: "",
      locations: [],
      selected_cities: [],
      cities: [],
      data: [],
      experiences: [],
      selected_job_experience: [],
      success: false,
    };
  },
  components: {
    Navbar,
    Switcher,
    Multiselect,
    Footer,
  },
  mounted() {var link = !!document.querySelector("link[rel='canonical']") ? document.querySelector("link[rel='canonical']") : document.createElement('link');
    link.setAttribute('rel', 'canonical');
    link.setAttribute('href', location.protocol + '//' + location.host + location.pathname);
    document.head.appendChild(link);
    IndexService.getCities().then((res) => {
      res.data.map((el) => {
        this.cities.push({
          id: el.id,
          value: el.city_name,
        });
      });
    });
    this.email = this.auth ? this.user.email : "";
    this.location = this.auth ? this.profile.city : "";
    this.getJobCareerLevel();
  },
  methods: {
    moment: function (date) {
      return moment(date);
    },
    getJobCareerLevel() {
      this.loading = true;
      axios.get(`${this.apiUrl}/get-job-career-levels`).then((response) => {
        this.experiences = response.data;
      });
    },
    submitJobAlert() {
      this.selected_cities.map((el) => {
        this.locations.push(el.value,);
      });
      this.success = true;
      if (!this.keywords) {
        Swal.fire({
          title: "",
          text: "Please enter keyword!",
          icon: "error",
          confirmButtonClass: "btn btn-secondary",
          heightAuto: false,
        });
        this.success = false;
        return;
      }
      if (
        !this.selected_job_experience ||
        this.selected_job_experience == null ||
        this.selected_job_experience == ""
      ) {
        Swal.fire({
          title: "",
          text: "Please select job experience!",
          icon: "error",
          confirmButtonClass: "btn btn-secondary",
          heightAuto: false,
        });
        this.success = false;
        return;
      }
      // if (this.selected_cities ) {
      //   Swal.fire({
      //     title: "",
      //     text: "Please select job location!",
      //     icon: "error",
      //     confirmButtonClass: "btn btn-secondary",
      //     heightAuto: false,
      //   });
      //   this.success = false;
      //   return;
      // }
      axios
        .post(`${API_URL}/job-alert`, {
          keywords: this.keywords,
          location: this.locations,
          career_level: this.selected_job_experience,
          email: this.email,
        })
        .then((res) => {
          this.success = true;
          setTimeout(() => {
            this.success = false;
          }, 3000);
          if (res.data === "200") {
            Swal.fire({
              title: "",
              text: "Job alert has been saved.",
              icon: "success",
              confirmButtonClass: "btn btn-secondary",
              heightAuto: false,
            });
            this.success = false;
          } else {
            Swal.fire({
              title: "",
              text: "Some thing went rong",
              icon: "error",
              confirmButtonClass: "btn btn-secondary",
              heightAuto: false,
            });
            this.success = false;
          }
        });
    },
    _jobCareerSelection(event) {
      if (event.target.checked) {
        if (!this.selected_job_experience.includes(event.target.value)) {
          var temp = this.selected_job_experience;
          temp.push(event.target.value);
          this.selected_job_experience = temp;
        }
      } else {
        var temp = [];
        this.selected_job_experience.forEach((element) => {
          if (element !== event.target.value) {
            temp.push(event.target.value);
          }
        });
        this.selected_job_experience = temp;
      }
    },
  },
};
</script>

<template>
  <div>
    <Navbar />

    <!-- Hero Start -->
    <section class="section_ch_p bg-light d-table w-100 mt-10">
      <div class="container">
        <div class="row">
          <div class="col-lg-8 col-md-8 pagech1">
            <div class="blog_header pl-0">
              <div class="col-lg-12 p-0 w-100">
                <div class="blog_back">
                  <i class="fas fa-long-arrow-alt-left p-1"></i>
                  <router-link to="/career-resources"
                    >Back to blog list</router-link
                  >
                </div>
              </div>
              <h2 class="m_title">Networking Skills</h2>
              <span class="m_title">by: job4u.pk (3 min read)</span>
            </div>

            <div class="p_about2">
              Love them or hate them, networking skills are widely considered
              the central tenet of success in the professional world. Having a
              strong network of contacts will help you develop and improve your
              skill set and stay on top of the latest trends in your industry,
              as well as giving you access to opportunities for growth and
              better opportunities. A steady channel of communication which
              allows for the exchange of information, advice, and support allows
              you to broaden your thinking, while having individuals of various
              experience and skill levels to discuss challenges and
              opportunities allows you access to valuable suggestions and
              guidance. Along with this, the social skills and self-confidence
              you build through networking are invaluable skills which can be
              taken wherever you go.
            </div>

            <div class="p_about2">
              So how exactly do you network effectively? Understandably, there’s
              no global fix that works for everyone, but we can think of a few
              tips and tricks that can help you maximize the benefits you reap
              from your networking efforts.
            </div>

            <div class="p_about2">
              Start with looking for and including the right people. The people
              in your network (virtual and/or physical) should be able to help
              you grow and diversify your skillset, and preferably be comprised
              of professionals both in your industry and in others. A good place
              to start is with professors and alumni from your educational
              institutes, colleagues and bosses from current and previous jobs,
              and friends and family in professional circuits.
            </div>

            <div class="p_about2">
              The next step is keeping in touch. Even if you don’t generally
              enjoy social interaction, it’s important to make your professional
              network valued – don’t just reach out to people when you need
              their help, but keep in casual touch with them throughout the
              year. How you do that is upto you, whether that’s through sharing
              posts on professional networking sites, invitations to networking
              events, or even a simple message sporadically throughout the year
              (sending interesting articles, greetings on special occasions, and
              invitations to opportunities they would appreciate, for example).
            </div>

            <div class="p_about2">
              How do you ensure that your network is diverse and growing? An
              excellent way to do so is by seeking out networking events, either
              physical or virtual. Networking events offer you the unique
              opportunity to interact with individuals of various skill levels
              and experience, which is unlikely to be a readily available option
              otherwise. This allows you to learn from and glean off individuals
              who have achieved more within your field, and, with some social
              skills, you may even find a friend or mentor who can offer you
              priceless guidance, advice, and opportunities within the field.
            </div>

            <div class="p_about2">
              Although these tips and tricks are definitely useful for building
              your network and developing networking skills, it is important to
              develop your own style and find a groove that works for you.
              Professional relationships are, after all, relationships, so don’t
              be afraid to add your own flair! Easily one of the best methods of
              success when it comes to establishing an effective network is
              individuality. Individuality allows you to stand out, and that
              makes you notable in the sea of professionals in both physical and
              virtual spaces.
            </div>
            <br />
            <!-- <hr> -->
          </div>
          <div class="col-lg-4 col-md-4 mt-3">
            <div class="card">
              <div class="back_overlay">
                <div class="row">
                  <div class="col-lg-6 col-10">
                    <h2 class="">want a great job taillard to your skills ?</h2>
                    <p class="">
                      save time and find higher quality jobs by signing up to
                      job4u.pk
                    </p>
                    <button type="submit" class="btn btn-default join_btn mb-6">
                      <a href="/job-seeker-register">Join job4u.pk now! </a>
                    </button>
                  </div>
                  <div class="col-lg-6 col-2 cv_image_bg">
                    <!-- <img src="/images/carer_resorses/CV.png" alt=""> -->
                  </div>
                </div>
              </div>
            </div>
            <div class="card mt-5">
              <div class="card-headerchch">Create a job alert!</div>
              <div class="card-body p-5">
                <form>
                  <div class="form-group">
                    <label class="labal_style" for="kyeword"
                      >keywords <span style="color: red">*</span></label
                    >
                    <input
                      type="text"
                      v-model="keywords"
                      class="form-control form-control-sm serach_i_ch"
                      id="kyeword"
                      placeholder="Enter Kyewords"
                    />
                  </div>

                  <div class="m_title pt-1 labal_style">
                    CAREER LEVELS <span style="color: red">*</span>
                  </div>
                  <div class="" style="">
                    <ul class="mt-2">
                      <li v-for="(item, index) in experiences" :key="index">
                        <input
                          type="checkbox"
                          :id="item.career_level"
                          :name="item.career_level"
                          class="custom-control-input"
                          :value="item.career_level"
                          v-on:click="_jobCareerSelection($event)"
                        /><label
                          class="custom-control-label"
                          :for="item.career_level"
                          style="font-size: 13px"
                          >{{ item.career_level }}</label
                        >
                      </li>
                    </ul>
                  </div>
                  <div class="form-group">
                    <label class="labal_style" for="exampleInputlocalisation1"
                      >Job Location</label
                    >
                    <div class="col-md-12 form-group m-0 p-0">
                      <multiselect
                        class="selectch home_city_selct"
                        id="multiselectCities"
                        v-model="selected_cities"
                        :height="300"
                        :options="cities"
                        :multiple="true"
                        :close-on-select="false"
                        :clear-on-select="false"
                        :preserve-search="true"
                        placeholder="location you love"
                        label="value"
                        track-by="value"
                        :preselect-first="false"
                      >
                      </multiselect>
                      <img
                        src="images/s_2.svg"
                        width="15"
                        height="15"
                        alt="..."
                        class="icon_search__"
                      />
                    </div>
                  </div>
                  <div class="form-group">
                    <label class="labal_style" for="exampleInputYouremail1"
                      >Your email<span style="color: red">*</span></label
                    >
                    <input
                      type="text"
                      v-model="email"
                      class="form-control form-control-sm serach_i_ch"
                      id="exampleInputYouremail1"
                      placeholder="Youremail"
                    />
                  </div>
                  <div>
                    <button
                      type="button"
                      class="card-headerch_btn bg_blue_ch"
                      @click="submitJobAlert()"
                      :class="
                        success ? 'spinner spinner-light pinner-right' : ''
                      "
                    >
                      Create job alert!
                    </button>
                    <!-- <div
                      v-if="success"
                      class="alert ml-5"
                      style="
                        background-color: #d4edda;
                        border-color: #d4edda;
                        color: #155724;
                      "
                      role="alert"
                    >
                      Form Submited
                    </div> -->
                  </div>
                </form>
              </div>
            </div>
          </div>
          <!--end col-->
        </div>
        <!--end row-->
      </div>
      <!--end container-->
    </section>
    <!--end section-->
    <!-- Hero End -->

    <Footer />
    <!-- Footer End -->
    <Switcher />
    <!-- Back to top -->
    <a
      href="javascript: void(0);"
      class="btn btn-icon btn-soft-primary back-to-top"
      id="back-to-top"
      v-scroll-to="'#topnav'"
    >
      <arrow-up-icon class="icons"></arrow-up-icon>
    </a>
    <!-- Back to top -->
  </div>
</template>
